import { memo } from 'react';
import NextLink from 'next/link';
import { Text, VStack, Link, HStack, List, ListItem } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';

import check from 'assets/icons/check.svg';

const CooperationCard = ({
  pos,
  max,
  tag,
  tagProps = null,
  title,
  description = null,
  list = null,
  img,
  imgProps = null,
  link = null,
  buttonHandler = null,
  buttonText = null,
  buttonProps = null,
  headerStyle = null,
  contentContainerProps = null,
  textContainerProps = null,
  descriptionSx = null,
  sxCard = null,
  ...props
}) => (
  <VStack
    w="full"
    align="start"
    gap="0"
    bgColor="bg.gray"
    p={{
      laptop: '48px 0px 48px 80px',
      tablet: '24px 0px 24px 32px',
      mobile: '16px 24px',
    }}
    borderRadius={{ laptop: '48px', mobile: '24px' }}
    h={{ desktop: '600px', laptop: '422px', tablet: '320px', mobile: 'fit-content' }}
    overflow="hidden"
    sx={sxCard}
    {...props}
  >
    <Text textStyle="h3">
      0{pos} — 0{max}{' '}
      <Text as="span" hideBelow="tablet" {...tagProps}>
        {tag}
      </Text>
    </Text>

    <HStack
      w="full"
      flexDir={{ tablet: 'row', mobile: 'column-reverse' }}
      justify="space-between"
      gap="0"
      {...contentContainerProps}
    >
      <VStack
        w="full"
        h="full"
        justify={{ tablet: 'center', mobile: 'start' }}
        align="start"
        gap={{ tablet: '24px', mobile: '16px' }}
        pos="relative"
        zIndex="10"
        {...textContainerProps}
      >
        <Text as="h3" {...headerStyle}>
          {title}
        </Text>

        {description && (
          <Text
            textStyle="h1"
            color="text.darkGray"
            fontWeight="500"
            maxW={{ laptop: '680px', desktop: 'unset' }}
            {...descriptionSx}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}

        {list && (
          <List spacing={{ mobile: '12px', laptop: '16px' }}>
            {list.map((text, i) => (
              <ListItem key={i} display="flex" flexDir="row" gap="12px">
                <NextImage
                  src={check}
                  alt="Галочка"
                  w="auto"
                  h="auto"
                  boxSize="24px"
                  mt={{ laptop: '6px' }}
                />

                {text}
              </ListItem>
            ))}
          </List>
        )}

        {link && (
          <Link
            as={NextLink}
            href={link}
            textStyle="button.secondary"
            textDecoration="underline"
            textUnderlineOffset="0.25em"
            _after={{ content: `'.'`, color: 'bg.accent' }}
          >
            Подробнее
          </Link>
        )}

        {buttonHandler && (
          <Text
            cursor="pointer"
            pt={{ mobile: '8px', laptop: '12px' }}
            textStyle="button.secondary"
            textDecoration="underline"
            textUnderlineOffset="0.25em"
            _after={{ content: `'.'`, color: 'bg.accent' }}
            onClick={buttonHandler}
            {...buttonProps}
          >
            {buttonText}
          </Text>
        )}
      </VStack>

      <NextImage src={img} alt={title} objectFit="contain" h="full" zIndex="1" {...imgProps} />
    </HStack>
  </VStack>
);

export default memo(CooperationCard);
